<template>
    <div>
        <vs-card>
            <div class="flex">
                <!-- Дата -->
                <vs-chip transparent color="primary">
                    {{ data_mom }}
                </vs-chip>
                <!-- Статус -->
                <vs-chip class="ml-2" :color="color">
                    {{ statusReq }}
                </vs-chip>
            </div>

            <div class="flex flex-wrap mt-4">
                <!-- Картинка -->
                <div class="px-4" style="min-width: 35%">
                    <img
                        style="max-width: 30vw; max-height: 200px"
                        :src="logo"
                    />
                </div>

                <div style="" class="lg:flex justify-between mt-2">
                    <div>
                        <!-- Название -->
                        <h4>
                            {{ title }}
                        </h4>
                        <!-- Тип -->
                        <div class="flex mt-2 text-base">
                            <span class="font-bold">{{ $t("type") }}: </span>
                            <span class="ml-2">{{ type }}</span>
                        </div>
                        <!-- Статус -->
                        <div class="flex text-base">
                            <span class="font-bold">{{ $t("status") }}:</span>
                            <span class="ml-2">{{
                                status ? $t("closed1") : $t("public")
                            }}</span>
                        </div>
                        <!-- Факультет -->
                        <div class="flex text-base flex-wrap lg:flex-nowrap">
                            <span class="font-bold"
                                >{{ $t("faculties") }}:</span
                            >
                            <span class="lg:ml-2 w-full lg:w-auto">{{ faculty }}</span>
                        </div>
                        <!-- Руководитель -->
                        <div class="flex text-base flex-wrap lg:flex-nowrap">
                            <span class="font-bold">{{ $t("director") }}:</span>
                            <span class="lg:ml-2 w-full lg:w-auto"
                                >{{ director.lastName }}
                                {{ director.firstName }}
                                {{ director.middleName }}</span
                            >
                        </div>
                    </div>
                    <!-- Ссылки на соц сети -->
                    <div v-if="soclinks.length > 0" class="mt-3 lg:mt-8 lg:ml-4 text-base">
                        <span class="font-bold">{{ $t("social_link") }}:</span>
                        <div
                            v-for="link in soclinks"
                            :key="link.uid"
                            class="flex text-base"
                        >
                            <a
                                class="font-bold"
                                :href="link.social_link"
                                target="_blank"
                                >{{ link.social_web_type.name }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <!-- Опсиание -->
            <div class="flex-col lg:ml-2 mt-2">
                <h5>{{ $t("description") }}:</h5>

                <p class="mt-2 text-base">
                    {{ description }}
                </p>
            </div>
            <!-- Коменнтарии -->
            <div v-if="comment" class="flex-col ml-2 mt-2">
                <h5>{{ $t("comments") }}:</h5>

                <p class="mt-2 text-base">
                    {{ comment.text }}
                </p>
            </div>
            <!-- Кнопки -->
            <div
                v-if="!my"
                :class="wMobile ? 'flex-col' : ''"
                class="flex justify-end"
            >
                <vx-tooltip class="ml-2" :text="$t('revision')" color="warning">
                    <feather-icon @click="modification" icon="EditIcon" class="cursor-pointer text-warning"></feather-icon>
                </vx-tooltip>
                <vx-tooltip class="ml-2" :text="$t('reject')" color="danger">
                    <feather-icon @click="cancel" icon="XCircleIcon" class="cursor-pointer text-danger"></feather-icon>
                </vx-tooltip>
                <vx-tooltip class="mx-2" :text="$t('accept')" color="success">
                    <feather-icon @click="accept" icon="CheckCircleIcon" class="cursor-pointer text-success"></feather-icon>
                </vx-tooltip>
            </div>
            <div v-else class="flex justify-end">
                <vx-tooltip :text="$t('edit')" color="warning">
                    <feather-icon @click="
                        $router.push({
                            name: 'stud-clubs-create',
                            query: { my: true },
                            params: { myData: item },
                        })
                    " icon="EditIcon" class="cursor-pointer text-warning"></feather-icon>
                </vx-tooltip>

            </div>
        </vs-card>
    </div>
</template>

<script>
export default {
    name: "RegCard",
    props: {
        date: [String],
        item: {
            type: [Object],
        },
        statusReq: [String],
        title: [String],
        type: [String],
        status: [String, Boolean],
        faculty: [String],
        description: [String],
        logo: [String],
        color: [String],
        comment: [String],
        data_created: [String],
        my: [Boolean, String],

        director: [Object],
        soclinks: [Array],
    },
    data() {
        return {};
    },
    computed: {
        data_mom(){
            return this.$moment(this.data_created).format('DD.MM.YYYY')
        },
        wMobile() {
            return window.innerWidth < 800;
        },
    },
    methods: {
        accept() {
            this.$emit("accept");
        },
        cancel() {
            this.$emit("cancel");
        },
        modification() {
            this.$emit("modification");
        },
    },
};
</script>

<style>
</style>
